export const createAction = <A, P>(type: A) => (payload: P): {payload: P, type: A} => ({ payload, type })